<template>
    <div class="home-event-card-thumbnail brand-text shadow bg-white h-100">
        <div class="d-flex flex-column mx-0 event-card-content">
            <img class="w-100 thumbnail" :src="item.thumbnail" />
            <div class="px-3 py-3 d-flex flex-column">
                <h3 class="truncate">{{ item.title }}</h3>
                <p v-if="item.description" class="truncate-3 p-text-sm pt-3">{{ item.description }}</p>
                <div class="mt-auto d-flex flex-row align-items-center justify-content-end">
                    <b-button @click="navigate('/stand-alone-article/' + item.id)" variant="white" size="lg"
                        style="margin-left: -15px;">View article <i class="fa-regular ml-2 fa-chevron-right"></i></b-button>
    
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>

export default {
    components: {
    },
    name: "HomeEventCard",
    props: {
        item: Object,
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    beforeDestroy() {

    },
    methods: {
        navigate(route) {
            this.$router.push(route);
            this.scrollToRef(null, true);

        },
        bookNow(event) {
            this.$router.push('/wellbeing-studio/' + event.id)
        },
    }
}
</script>
<style lang="less">
.home-event-card-thumbnail {
    border-radius: 6px;

    .thumbnail{
        aspect-ratio: 16/9;
        overflow: hidden;
        border-radius: 6px 6px 0 0;
    }
    .event-card-content {
        overflow: hidden;
        height: 100%;
    }

    hr {
        height: 1px;
        width: 100%;
    }

    .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /* number of lines to show */
        line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .truncate-3 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /* number of lines to show */
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>